import React, { useCallback } from 'react'
import LandingLogo from 'components/molecules/LandingLogo'
import { sendMessageOutsideIframe } from 'utils/game.utils'
import './GameInactivePage.scss'

const BackIcon = () => (
  <svg viewBox='0 0 16 16' fill='none' aria-hidden='true'>
    <path d='M10 3.5 5.5 8 10 12.5' stroke='currentColor' strokeWidth='1.6' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
)

const GameInactivePage = ({
  gameName = '',
  gameId,
  kicker = 'Temporarily closed',
  heading = 'This game is inactive',
  message,
  showMoreGames = true
}) => {
  const title = gameName || 'This game'

  const leave = useCallback((eventName, data) => {
    if (window.parent && window.parent !== window) {
      sendMessageOutsideIframe(eventName, data)
    }
  }, [])

  return (
    <div className='v2-game-inactive'>
      <div className='v2-game-inactive-glow' aria-hidden='true' />
      <div className='v2-game-inactive-brand'>
        <LandingLogo className='v2-game-inactive-logo' />
      </div>

      <div className='v2-game-inactive-stage'>
        <div className='v2-game-inactive-card'>
          <div className='v2-game-inactive-mark' aria-hidden='true'>
            <span className='v2-game-inactive-mark-ring' />
            <img src='/assets/images/svg/info.svg' alt='' />
          </div>
          <p className='v2-game-inactive-kicker'>{kicker}</p>
          <h1>{heading}</h1>
          <p className='v2-game-inactive-copy'>
            {message || (
              <>
                <strong>{title}</strong> is turned off right now. Tables are closed until it is switched back on.
              </>
            )}
          </p>
          <div className='v2-game-inactive-actions'>
            <button type='button' className='v2-game-inactive-btn v2-game-inactive-btn--ghost' onClick={() => leave('RETURN_TO_LANDING')}>
              <BackIcon />
              Back
            </button>
            {showMoreGames ? (
              <button type='button' className='v2-game-inactive-btn v2-game-inactive-btn--primary' onClick={() => leave('OPEN_MORE_GAMES', { gameId })}>
                More Games
              </button>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  )
}

export default GameInactivePage
